import React, {Component} from 'react';
import Menu from "../components/Menu";
import {connect} from "react-redux";
import { Scrollbars } from 'react-custom-scrollbars';
import {Popover, Tree, Menu as AntdMenu, Dropdown, Icon,message} from 'antd';
import {
    autoChangeNavigateStauts,
    changeNavigateStauts,
    loadNavigateData, refreshPage, setInfoToLocalStorage,
    shrinNavigateStauts,
    updataNavigateData, updateNavigateLevel2Data
} from "../actions";
import LogoArea from "./logoArea";
import {uuid,findUrlData} from "../utils";
import {LOGO_HEIGHT, NAVIGATE_LEVEN2_MARGIN, NAVIGATE_LEVEN2_WIDTH} from "../constants";
import   "./newSecondOrThird.css"
import IconFont from "../view/components/svgIcon/IconFont.js"
import BaseComponent from "../base/BaseComponent";
import  {Link} from "react-router-dom"
import {getInfoFromLocalStorage} from"../actions/index"
import ReleaseMedia from '../view/mediaRelease/releaseMedia/ReleaseMedia'


class PmsNavigateLevel1 extends BaseComponent {

    componentDidMount() {
        if(!this.props.initNavigateData)//没有加载过的时候再去加载，避免每次请求都去加载
            this.props.loadNavigateData();
        window.addEventListener('resize', this.resize.bind(this));
        this.setState({
            navWidth:document.getElementById("header-nav").clientWidth
        })
    }

    state = {
        height: document.body.clientHeight - (this.props.navigateStatus?(175 + LOGO_HEIGHT):(98 + LOGO_HEIGHT)),
        navWidth:0,
    };
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            height: document.body.clientHeight - (nextProps.navigateStatus?(175 + LOGO_HEIGHT):(98 + LOGO_HEIGHT)),
            navWidth:document.getElementById("header-nav").clientWidth
        });
    }


    resize(){
        this.setState({
            height: document.body.clientHeight - (this.props.navigateStatus?(175 + LOGO_HEIGHT):(98 + LOGO_HEIGHT)),
            navWidth:document.getElementById("header-nav")?.clientWidth
        })
    }

    componentWillUnmount() {
        window.removeEventListener('resize',this.resize);
        this.setState = (state, callback) => {
            return;
        };

    }

    render() {
        let {config} = this.getInfo();
        let navWidth = this.state.navWidth;
        let itemWidth=config && config.getValueByKey ? config.getValueByKey("comm.web.header.menu.width", '110') : '110';

        itemWidth=parseInt(itemWidth)

        let showMax=parseInt(navWidth/itemWidth)//-1;

        let defaultColor= config&&config.getValueByKey?config.getValueByKey("NewMenuDefaultColor", 'white'):'white';
        //新菜单一级菜单，加折叠适应，勿动
        let num=0;
        let content = [];
        let hideContent = [];
        let popoverNum=0;
        return <div style={{display:'flex'}}>
            {this.props.navigateData && this.props.navigateData.length?this.props.navigateData.map((one,index)=>{
                if(showMax>=this.props.navigateData.length || (showMax > (index + 1))){
                    num = index + 1;
                    return(
                        <Menu {...this.props} config={config} id={one.id} key={one.id} float={'left'} type={1}
                              icon={one.icon} menuName={one.menuName}>
                        </Menu>
                    )
                }else {
                    let menuComponent = <Menu {...this.props} config={config} id={one.id} key={one.id} float={'left'} type={1}
                                              isMore={true}
                          icon={one.icon} menuName={one.menuName}>
                    </Menu>;
                    hideContent.push(menuComponent);
                    popoverNum++;
                    if(index>num){
                        content.push(
                            <AntdMenu.Item key={one.id}>
                                <Menu ellipsis={true} {...this.props} config={config} id={one.id} key={one.id} float={'none'} type={1}
                                      icon={one.icon} menuName={one.menuName}>
                                </Menu>
                            </AntdMenu.Item>
                        )
                    }else{
                        content.push(
                            <AntdMenu.Item key={one.id}>
                                <Menu ellipsis={true} {...this.props} config={config} id={one.id} key={one.id} float={'none'} type={1}
                                      icon={one.icon} menuName={one.menuName}>
                                </Menu>
                            </AntdMenu.Item>

                        );
                        if(popoverNum > 1){
                            return <></>;
                        }
                        return(
                            <Dropdown key={one.id} overlay={ <AntdMenu>
                             {content}
                            </AntdMenu>} placement="bottomLeft">
                                <div className={'firstMenu'} style={{width: 100, float: 'left', textAlign: 'center',cursor:'pointer',fontSize:24,color:defaultColor,fontWeight:"700",letterSpacing: 5}}>...{hideContent}</div>
                            </Dropdown>
                        )
                    }

                }
            }):null
            }


        </div>;
    }
}

function mapStateToProps(state){
    return {
        checkMenuId: state.systemReducer.menuId,
        navigateData: state.systemReducer.navigateData,
        navigateStatus:state.systemReducer.navigateStatus,
        autoNavigateStatus: state.systemReducer.autoNavigateStatus,
        initNavigateData: state.systemReducer.initNavigateData,
        refersh: state.systemReducer.refersh,
        manualNavigateStatusTime:state.systemReducer.manualNavigateStatusTime,
    }
}

export default connect(mapStateToProps, {
    loadNavigateData, updataNavigateData, changeNavigateStauts, autoChangeNavigateStauts, shrinNavigateStauts, refreshPage, updateNavigateLevel2Data
})(PmsNavigateLevel1);


const { TreeNode, DirectoryTree } = Tree;
class PmsNavigateLevel2Component extends BaseComponent{

    constructor(props){
        super(props);

        this.state = {
            mediaList : []
        };

        this.getMediaList();
    }

    initSelectedKeysAndExpandedKeys(dataSource, parentId){
        let result = {
            selectedKey: null,
            expandedKeys: []
        };

        for(let i = 0 ; dataSource && i < dataSource.length; i++){
            let item = dataSource[i];
            if(item.child && item.child.length > 0){
                let res = this.initSelectedKeysAndExpandedKeys(item.child, item.id);
                if(res.selectedKey){
                    result.selectedKey = res.selectedKey;
                }
                if(res && res.expandedKeys && res.expandedKeys.length > 0){
                    result.expandedKeys.push(...res.expandedKeys)
                }
                if(item.check){//如果当前这个节点需要默认选中
                    result.expandedKeys.push(item.id);
                }
            }else{
                let path = window.location;
                try {
                    path = path.hash.replace("#", "");
                } catch (e) {
                    path = "/";
                }
                if(item.path === path /*|| (item.check && !result.selectedKey)*/){//如果当前路径是这个节点 //或者如果是当前这个节点需要默认选中，且没有选中任何节点时
                    result.selectedKey = item.id;
                    if(parentId)
                        result.expandedKeys.push(parentId);
                }
            }
             item.isExpand && result.expandedKeys.push(item.id);
        }
        return result;
    }

    onSelect = (keys, event) => {
        if(event.node.props.nosons){
            let values = null;
            if(typeof this.scrollbars?.getValues === "function") {
                values = this.scrollbars.getValues();
            }
            sessionStorage.setItem('navigateLevel2scrollbarsValues', JSON.stringify({
                ['#'+event.node.props.path]: {scrollbarsValues: values}
            }));
			let dataSource = Object.assign([],this.props.dataSource);

			let rootNode = {child:dataSource};
			this.upChecked(rootNode, event.node.props.path);
			updateNavigateLevel2Data(this.props.title, rootNode.dataSource);
			//新增打开新窗口的业务逻辑
            if(event.node.props.type=='_blank'){
                window.open(event.node.props.path)
            }else{
                window.location.hash = event.node.props.path;
            }
        }
    };

	//改变选中状态
	upChecked = (node, path) => {
		let child = node.child;
		node.check = false;
		node.status = "up";
		if(child && child.length > 0){
			let res = false;
			for(let i = 0 ; i < child.length; i++){
				if(this.upChecked(child[i], path)){
					node.check = true;
					node.status = "down";
					res = true;
				}
			}
			return res;
		}else{
			if(node.path === path){
				node.check = true;
				node.status = "down";
				return true;
			}
		}
		return false;
	}

    onExpand = () => {
    };

    showTreeNode = (dataSource) => {
        let { config } = this.getInfo();
        let newSecondSelectColor = this.themeBgColor;
        let width =  NAVIGATE_LEVEN2_WIDTH  - 95;

        switch (this.isNewMenu) {
            case '0':
                return dataSource.map(item => {
                    if (item.child && item.child.length > 0) {
                        return <TreeNode
                            showIcon={true}
                            icon={<img alt={item.menuName} src={item.ico ? item.ico : "images/contentfolder.gif"}/>}
                            title={item.menuName} key={item.id ? item.id : uuid()}>
                            {
                                this.showTreeNode(item.child)
                            }
                        </TreeNode>
                    } else {
                        let src = "";
                        if (item.ico === "image") {
                            src = "images/imagecontent.gif";
                        } else if (item.ico === "url") {
                            src = "images/urlcontent.gif";
                        } else {
                            src = "images/newscontent.gif";
                        }
                        return <TreeNode
                            nosons={true} path={item.path}
                            type={item.type}
                            icon={<img alt={item.menuName} src={item.ico ? item.ico : src}/>}
                            title={item.menuName} key={item.id ? item.id : uuid()}
                            isLeaf
                        />
                    }
                });
                break;
            case '1':
                return dataSource.map(item => {

                    if (item.child && item.child.length > 0) {
                        return <TreeNode
                            showIcon={true}
                            icon={<div style={{height:44,lineHeight:'44px'}}><img style={{width:16,height:16}} alt={item.menuName} src={item.ico ? item.ico : "images/contentfolder.gif"}/></div>}
                            title={ <span>
                                <span title={item.menuName} className={'secondOpen'} style={{
                                    fontSize: 15,
                                    maxWidth:width,
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                     display: "inline-block"
                                }}>{item.menuName}
                               </span>
                                <span id={'up'} style={{
                                    color: this.defaultColor,
                                     // display: 'inline-block'
                                }}>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span style={{float: 'right', lineHeight: '44px'}}> <img src="images/menu/newUp.png" alt=""/></span>
                                     </span>
                                <span id={'down'} style={{
                                    color: this.defaultColor,
                                     // display: 'inline-block'
                                }}>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span style={{float: 'right', lineHeight: '44px'}}> <img
                                        src="images/menu/newDown.png" alt=""/></span>
                                     </span>

                            </span>} key={item.id ? item.id : uuid()}>
                                {
                                    this.showTreeNode(item.child)
                                }
                            </TreeNode>
                        }
                   else {
                        let defaultIcon = "images/contentfolder.gif"
                        return <TreeNode
                            nosons={true}
                            path={item.path}
                            type={item.type}
                            icon={
                                <div style={{ height: 44, lineHeight: '44px' }} >
                                    {
                                        item.ico ?
                                            <img style={{ width: 16, height: 16 }} alt={item.menuName} src={item.ico} /> :
                                            item.svg ? <IconFont type={item.svg} /> :
                                                <img style={{ width: 16, height: 16 }} alt={item.menuName} src={defaultIcon} />
                                    }
                                </div>}
                            title={
                                <span style={{ fontSize: 15, maxWidth:width,
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',display: "inline-block"
                                }} title={item.menuName}>
                                    {item.menuName}
                                </span>
                            }
                            key={item.id ? item.id : uuid()}
                            isLeaf
                        />
                    }
                });
                break;
            default:
                return dataSource.map(item => {
                    if (item.child && item.child.length > 0) {
                        return <TreeNode
                            // switcherIcon={<Icon type="caret-down" />}
                            showIcon={true}
                            icon={<img alt={item.menuName} src={item.ico ? item.ico : "images/contentfolder.gif"}/>}
                            title={item.menuName} key={item.id ? item.id : uuid()}>
                            {
                                this.showTreeNode(item.child)
                            }
                        </TreeNode>
                    } else {
                        let src = "";
                        if (item.ico === "image") {
                            src = "images/imagecontent.gif";
                        } else if (item.ico === "url") {
                            src = "images/urlcontent.gif";
                        } else {
                            src = "images/newscontent.gif";
                        }
                        return <TreeNode
                            nosons={true} path={item.path}
                            type={item.type}
                            icon={<img alt={item.menuName} src={item.ico ? item.ico : src}/>}
                            title={item.menuName} key={item.id ? item.id : uuid()}
                            isLeaf
                        />
                    }
                })

        }

    };

    showTreeNodeChid(dataSource) {
        return dataSource.map(item => {
            return <TreeNode
                nosons={true} path={item.path}
                icon={<span></span>}
                title={<span style={{/*olor:item.check?this.newSecondSelectColor:this.defaultColor,*/fontSize:15}}>{item.menuName}</span>} key={item.id ? item.id : uuid()}
                isLeaf
            />
        });
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.getMediaList();
    }
    componentDidMount() {
        let hash = window.location.hash;
        let navigateLevel2scrollbarsValues = sessionStorage.getItem('navigateLevel2scrollbarsValues');
        try {
            navigateLevel2scrollbarsValues = JSON.parse(navigateLevel2scrollbarsValues);
            let hashInfo = navigateLevel2scrollbarsValues?.[hash];
            let scrollbarsValues = hashInfo?.scrollbarsValues;
            this.scrollbarsValues = scrollbarsValues;
        } catch (e) {
            this.scrollbarsValues = undefined
        }
        if(this.scrollbars && this.scrollbarsValues) {
            if(this.scrollbarsValues.scrollTop >0 && typeof this.scrollbars.scrollTop === "function") {
                this.scrollbars.scrollTop(this.scrollbarsValues.scrollTop)
            }
            if(this.scrollbarsValues.scrollLeft >0 && typeof this.scrollbars.scrollLeft === "function") {
                this.scrollbars.scrollLeft(this.scrollbarsValues.scrollLeft)
            }
        }
    }

    getMediaList = () =>{
        let currentMediaList = getInfoFromLocalStorage('currentMediaList') || [];
        if (currentMediaList && currentMediaList.length < 1) {
            this.getCurrentMediaList().then((res) => {
                let mediaList=[];
                if (res && res.length) {
                    mediaList=res
                }
                setInfoToLocalStorage("currentMediaList", mediaList);
                this.setState({
                    mediaList: mediaList
                });
            });
        } else {
            this.state.mediaList = currentMediaList;
        }
    };
    jump = (item) => {
        this.releaseMedia&&this.releaseMedia.menuClick(item)
    };
    scrollbars = null;
    render() {
        let {config} = this.getInfo();
        let isNewMenu = config&&config.getValueByKey?config.getValueByKey("NewMenu", '1'):'1';
        let newSecondDefaultColor=config&&config.getValueByKey?config.getValueByKey("newSecondDefaultColor", 'black'):'black';
        let newSecondSelectColor = this.themeBgColor;
        this.defaultColor = newSecondDefaultColor;
        this.newSecondSelectColor= this.themeBgColor;
        //这是默认没修改的导航
        let secondTitle;
        let title=this.props.title;
        this.isNewMenu=isNewMenu;
        //下面紧跟这的判断是解决顶部菜单 ... 不触发不渲染左侧二级菜单的问题
        let dataSource=this.props.dataSource;
        if(dataSource && dataSource.length > 0){
            let res = this.initSelectedKeysAndExpandedKeys(dataSource);//（受控）设置选中的树节点
            let {selectedKey, expandedKeys} = res;
            let selectedKeys = [];
            if(selectedKey)
                selectedKeys.push(selectedKey);

            //融媒发布是否隐藏左侧菜单。默认点击进入融媒发布是的时候隐藏左侧的菜单,
            // 融媒发布新菜单，只展示当前跳转媒体的菜单
            let showLeftMenu=true;
            let hashUrl= window.location.hash;//确认融媒发布的路由
            if((isNewMenu==='1'&&!selectedKey)/*||(isNewMenu==='1'&&hashUrl==="#/resource/list")*/){
                showLeftMenu=false;
            }
            let dataSource2=[];

            if(this.state.mediaList&&this.state.mediaList.length){
                dataSource2=dataSource;
            }
            //媒体发布只显示当前媒体的菜单-----------------------
            let currentUrl=window.location.hash;
            let isReleaseMediaStatus=false;
            let currentMenu={};
            let currentMediaList = this.state.mediaList;
            if(selectedKey&&isNewMenu==='1'){
                dataSource.forEach((item,i)=>{
                    if(item.jumpType === "1"){ // 旧版定制菜单，旧版本中有一个逻辑是融媒发布的菜单需要去展示当前媒体下的所有菜单
                        if(item.menuCode&&currentUrl.indexOf(item.menuCode)>-1){
                            isReleaseMediaStatus=true;
                            let newDataSource = [];
                            //newDataSource.push(item);//包含文件夹，融媒发布，当前最顶层是媒体名称
                            if (item.child.length > 1) {
                                newDataSource.push(item);
                                currentMenu=item
                            }
                            //这块是包含媒体层
                            // dataSource = newDataSource;
                            //这块是不包含媒体层
                            if(newDataSource&&newDataSource.length){
                                dataSource=newDataSource[0].child
                            }else{
                                dataSource=[];
                            }
                            if (!dataSource.length) {
                                // 融媒发布只有一级菜单得时候不展示
                                showLeftMenu = false;
                            }
                            return
                        }
                    }
                });
            }

            //获取当前图标
            let currentLogo = '';
            currentMediaList.forEach((Item, Index) => {
                if (Item.mediaList) {
                    Item.mediaList.forEach((item, index) => {
                        if (currentMenu.menuCode && item.id == currentMenu.menuCode) {
                            currentLogo = item.mediaLogo ? item.mediaLogo : Item.logoUrl ? Item.logoUrl : '';
                        }
                        dataSource2.forEach((i, index) => {
                            if (i.menuCode == item.id) {
                                dataSource2[index].logoUrl = item.mediaLogo ? item.mediaLogo : Item.logoUrl ? Item.logoUrl : '';
                                dataSource2[index].sort = item.sort ? item.sort : 0;
                            }
                        })
                    })
                }
            });
            //按sort排序
            dataSource2.sort((a, b) => {
                return a.sort - b.sort
            })
            // 左侧栏类型下拉
            let currentMenus = [];
            dataSource2.filter((item, index) => {
                if (item.menuName !== currentMenu.menuName) { //删除当前选中菜单
                    if (item.path && item.logoUrl) {
                        currentMenus.push(
                            <AntdMenu.Item key={index}>
                                <div rel="noopener noreferrer" onClick={() => {
                                    this.jump(item)
                                }}>
                                    <div style={{ display: 'flex' }}>
                                        <img style={{
                                            width:16,
                                            height: 16,
                                            alignSelf: 'center',
                                            marginRight: 5,
                                            borderRadius: '50%',
                                            objectFit: 'cover'
                                        }}
                                            src={item.logoUrl} />
                                        <div style={{
                                            width: 200,
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis'
                                        }}>{item.menuName}</div>
                                    </div>
                                </div>
                            </AntdMenu.Item>
                        )
                    }
                }
            });
            let menu = (
                <AntdMenu>
                    {currentMenus}
                </AntdMenu>
            );
            switch (isNewMenu) {
                case '0':
                    secondTitle = <div
                        style={{width: "100%", height: "42px", borderBottom: "1px solid #e1e1e1", textAlign: "center"}}>
                        <span style={{lineHeight: "42px", fontSize: "14px", color: "#333"}}>{title}</span>
                    </div>;
                    break;
                case '1':
                    secondTitle=<div style={{width:"100%", height:"42px", paddingLeft:"30px",display:isReleaseMediaStatus?'none':''}}>
                                <span style={{lineHeight:"42px",fontSize:"18px", color:"#333"}}><b>{title}</b></span>
                              </div>
                    break;
                default:
                    secondTitle = <div
                        style={{width: "100%", height: "42px", borderBottom: "1px solid #e1e1e1", textAlign: "center"}}>
                        <span style={{lineHeight: "42px", fontSize: "14px", color: "#333"}}>{title}</span>
                    </div>;

            }

            //媒体发布只显示当前媒体的菜单------------------------
      
            return (<div className={isNewMenu === '1' ? 'secondMenu' : 'null'} style={{
                borderRadius: "5px",
                width: NAVIGATE_LEVEN2_WIDTH + "px",
                height: "calc(100vh - 100px)",
                margin: isNewMenu === '1' ? `${NAVIGATE_LEVEN2_MARGIN}px 0 0 0` : NAVIGATE_LEVEN2_MARGIN + "px 0px " + NAVIGATE_LEVEN2_MARGIN + "px " + NAVIGATE_LEVEN2_MARGIN + "px",
                float: "left",
                background: "#fff",
                display: showLeftMenu ? 'block' : 'none'
            }}>
                {/*左侧栏头部类型*/}
                {this.state.mediaList && this.state.mediaList.length ?
                    <>
                        <div style={{display: isReleaseMediaStatus ? '' : 'none'}}>
                            <Dropdown overlay={menu} overlayStyle={{width: 240}}>
                                <span style={{display: 'flex', alignItems: 'center'}}>
                                <span title={currentMenu.menuName} style={{
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    color: '#222',
                                    padding: '12px 0px 12px 24px',
                                    width: '170px',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis'
                                }}>{currentMenu.menuName}
                                </span>
                                <Icon type="down" style={{cursor: 'pointer', marginRight: 15}}/>
                                    {
                                        <img src={currentLogo} style={{
                                            width: 24,
                                            height: 24,
                                            borderRadius: '50%',
                                            objectFit: 'cover'
                                        }} alt=""/>
                                    }
                                </span>
                            </Dropdown>
                        </div>

                        {secondTitle}
                    </>
                    :<> {secondTitle}  </>
                }
                <style>
                    {`

                .secondMenu .ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before,
                .secondMenu .ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before
                {
                     background:rgba(0, 80, 179, 0.08) !important
                    border-right: 4px solid ${newSecondSelectColor} !important;
                     font-weight:bold !important
                }
                 /* .secondMenu .ant-tree-treenode-selected{
                  font-weight:bold !important
                  }*/
                
                /*下面是三级导航右边紫色的线*/
                
                .secondMenu  .ant-tree.ant-tree-directory .ant-tree-child-tree-open > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before {
                      background:rgba(0, 80, 179, 0.08) !important
                    border-right: 4px solid ${newSecondSelectColor} !important;
                    font-weight:bold !important
                    /*color:#7c53c9 !important;*/
                }
                .secondMenu .ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before{
                   background:rgba(0, 80, 179, 0.08) !important}
                .secondMenu  .ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper.ant-tree-node-selected,
                .secondMenu  .ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper.ant-tree-node-selected{
                    color: ${newSecondSelectColor}!important ;
                     font-weight:bold !important
                }
                .secondMenu  .ant-tree li .ant-tree-node-content-wrapper {
                    color:${newSecondDefaultColor} !important;
                }
                .secondMenu .ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before{
                     background:rgba(0, 80, 179, 0.08) !important
                }
                    `
                    }
                </style>
                <Scrollbars style={{height: "calc(100vh - 155px)"}}
                            autoHide
                            ref={ref=>this.scrollbars=ref}
                >
                    <DirectoryTree
                        // showLine
                        // switcherIcon={<Icon type="caret-down" />}
                        key={uuid()}
                        switcherIcon={<span></span>}
                        defaultSelectedKeys={selectedKeys}
                        defaultExpandedKeys={expandedKeys}
                        multiple
                        onSelect={this.onSelect.bind(this)}
                        onExpand={this.onExpand}>
                        {
                            this.showTreeNode(dataSource)
                        }
                    </DirectoryTree>
                    {
                        dataSource2 && dataSource2.length ? <div style={{display: 'none'}}>
                            <ReleaseMedia ref={(releaseMedia) => {
                                this.releaseMedia = releaseMedia
                            }}></ReleaseMedia>
                        </div> : null
                    }
                </Scrollbars>
            </div>)
        }else{
            return <div></div>
        }
    }

}
PmsNavigateLevel2Component.defaultProps = {
    title: "新闻网",
    dataSource : []
};

function mapStateToPropsPmsNavigateLevel2(state){
    return {
        title: state.systemReducer.navigateLevel2Title,
        dataSource: state.systemReducer.navigateLevel2Data,
        config:state.systemReducer.config,
    }
}
export const PmsNavigateLevel2 = connect(mapStateToPropsPmsNavigateLevel2,{updateNavigateLevel2Data})(PmsNavigateLevel2Component);
